exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3b0HwBS9otJ07ATTlts67s {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  padding: 24px 16px;\n  background-color: #f2faff; }\n  ._3b0HwBS9otJ07ATTlts67s ._2v_8Udi6WGMdxyBCtGyez4 {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 16px;\n    max-width: 480px;\n    text-align: center;\n    color: #111111; }\n  ._3b0HwBS9otJ07ATTlts67s ._3Z2za9DqbRfKVS_E2PRTvl {\n    margin: 0;\n    font-size: 16px;\n    line-height: 20px;\n    font-weight: 700;\n    text-wrap: pretty; }\n  ._3b0HwBS9otJ07ATTlts67s ._3mWJKIeV8FW5ZgSzYtM_M {\n    min-width: 240px;\n    text-align: left; }\n  ._3b0HwBS9otJ07ATTlts67s ._2vGX7Zs17ELB2DSxd1DrhX {\n    padding: 0;\n    border: 0;\n    background: none;\n    font-size: 14px;\n    line-height: 20px;\n    color: #424242;\n    text-decoration: underline;\n    cursor: pointer; }\n", ""]);

// exports
exports.locals = {
	"takeover": "_3b0HwBS9otJ07ATTlts67s",
	"content": "_2v_8Udi6WGMdxyBCtGyez4",
	"heading": "_3Z2za9DqbRfKVS_E2PRTvl",
	"switcher": "_3mWJKIeV8FW5ZgSzYtM_M",
	"logout": "_2vGX7Zs17ELB2DSxd1DrhX"
};